import script from "./QuestionSlide.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionSlide.vue?vue&type=script&setup=true&lang=js"

import "./QuestionSlide.vue?vue&type=style&index=0&id=9ff358f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ff358f6"]])

export default __exports__